import * as yup from 'yup';

export const noRuEmailDomainValidator: yup.TestConfig = {
	message: '.ru domain is forbidden for email',
	test: (value?: unknown) => !(value as string)?.toLowerCase().endsWith('.ru'),
};

export const noCiryllicCharsEmailDomainValidator: yup.TestConfig = {
	message: 'cyrillic chars are forbidden for email',
	// @ts-ignore
	test: (value?: unknown, context) => !/[\u0400-\u04FF]/.test(value as string),
};
